const INTEG_CONFIG = {"REACT_APP_USER_POOL_ID":"us-west-2_c9i5jrayl",
    "REACT_APP_USER_POOL_WEB_CLIENT_ID":"6u8hmphi7vo6ornvnsps78jrjb",
    "REACT_APP_COGNITO_DOMAIN":"cog-approvermatrix-na-integ.auth.us-west-2.amazoncognito.com",
    "REACT_APP_REDIRECT_URL":"https://integ.checkpoint.lab126.amazon.dev",
    "REACT_APP_API_ENDPOINT":"https://yeanhu6g73.execute-api.us-west-2.amazonaws.com/Gamma"}

export default INTEG_CONFIG